// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__dH-5w","legacyBtn":"MutateMid_legacyBtn__1weSK"};